import { EntityModules } from 'core/constants';

export type SupportedEntityModule = EntityModules.Sites | EntityModules.Assets | EntityModules.Contacts;

export const supportedEntityModules = new Set<EntityModules>([
  EntityModules.Sites,
  EntityModules.Assets,
  EntityModules.Contacts,
]);

export const entityPropertyMap: Record<SupportedEntityModule, 'site' | 'asset' | 'contact'> = {
  [EntityModules.Sites]: 'site',
  [EntityModules.Assets]: 'asset',
  [EntityModules.Contacts]: 'contact',
};
